/**
 * ExportCSVButton Component
 * Reusable button component for CSV export functionality
 */

import React from 'react';
import { Button, Spinner } from 'react-bootstrap';

const ExportCSVButton = ({ 
  onExport, 
  loading = false, 
  disabled = false,
  variant = 'outline-success',
  size = 'sm',
  className = ''
}) => {
  return (
    <Button 
      variant={variant} 
      size={size}
      onClick={onExport}
      disabled={disabled || loading}
      className={className}
    >
      {loading ? (
        <>
          <Spinner 
            as="span" 
            animation="border" 
            size="sm" 
            className="me-2" 
            role="status" 
            aria-hidden="true"
          />
          Esportazione in corso...
        </>
      ) : (
        <>
          <i className="fas fa-file-csv me-2"></i>
          Esporta CSV
        </>
      )}
    </Button>
  );
};

export default ExportCSVButton;
